// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-dom/src/Css.js");
var React = require("react");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Graph$BlossomPlayground = require("./Graph.bs.js");
var ForceGraph$BlossomPlayground = require("./ForceGraph.bs.js");
var GraphTable$BlossomPlayground = require("./GraphTable.bs.js");
var SampleData$BlossomPlayground = require("./SampleData.bs.js");

var vertices = Graph$BlossomPlayground.verticesToArray(SampleData$BlossomPlayground.a);

function editVertex(param) {
  
}

function editEdge(param, param$1, param$2) {
  
}

function Intro(Props) {
  var close = Props.close;
  var mates = Graph$BlossomPlayground.Mates.useMates(undefined, SampleData$BlossomPlayground.a);
  return React.createElement("article", {
              className: "intro"
            }, React.createElement("h2", undefined, "Welcome to the maximum weighted matching finder"), React.createElement("p", undefined, "This is an app for finding matches on weighted graphs. If you're new\n       to this topic, here's a quick introduction."), React.createElement("p", {
                  style: Css.style({
                        hd: Css.textAlign(/* center */98248149),
                        tl: /* [] */0
                      })
                }, React.createElement("button", {
                      className: "font-small",
                      onClick: (function (param) {
                          return close();
                        })
                    }, "Skip this and take me to the app.")), React.createElement("p", undefined, "Suppose you have a list of chess players: ", React.createElement("em", undefined, "Mary, Joseph, Matthew, Mark, Luke, John, Peter, Andrew, James,"), " and ", React.createElement("em", undefined, "Philip"), ", and you want to pair them to compete in a tournament round."), React.createElement("p", undefined, "Your first step is to list all of your possible pairings."), React.createElement("ul", undefined, Belt_Array.map([
                      "Mary, Joseph",
                      "Mary, Matthew",
                      "Joseph, Matthew",
                      "Joseph, Mark",
                      "Matthew, Luke",
                      "Mark, Luke",
                      "Mary, Andrew",
                      "Luke, Peter",
                      "Peter, John",
                      "Andrew, Philip",
                      "Mark, James"
                    ], (function (s) {
                        return React.createElement("li", {
                                    key: s
                                  }, s);
                      }))), React.createElement("p", undefined, "(This isn't ", React.createElement("em", undefined, "all"), " possible pairings, but for brevity we'll stick to this list.\n       In practice, your list will usually be much longer.)"), React.createElement("p", undefined, "Next, you will need to determine the ", React.createElement("em", undefined, "weight"), " of each pairing. This is a floating-point number that indicates how\n       desirable that pairing is."), React.createElement("table", {
                  style: Css.style({
                        hd: Css.margin(/* auto */-1065951377),
                        tl: {
                          hd: Css.borderCollapse(/* collapse */-996847251),
                          tl: /* [] */0
                        }
                      })
                }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("th", {
                              colSpan: 2,
                              scope: "col"
                            }, "Pair"), React.createElement("th", {
                              scope: "col"
                            }, "Weight")), Belt_Array.map([
                          [
                            "Mary",
                            "Joseph",
                            40
                          ],
                          [
                            "Mary",
                            "Michael",
                            40
                          ],
                          [
                            "Joseph",
                            "Michael",
                            60
                          ],
                          [
                            "Joseph",
                            "Gabriel",
                            55
                          ],
                          [
                            "Michael",
                            "Raphael",
                            55
                          ],
                          [
                            "Gabriel",
                            "Raphael",
                            50
                          ],
                          [
                            "Mary",
                            "Paul",
                            15
                          ],
                          [
                            "Raphael",
                            "Peter",
                            30
                          ],
                          [
                            "Peter",
                            "John",
                            10
                          ],
                          [
                            "Paul",
                            "James",
                            10
                          ],
                          [
                            "Gabriel",
                            "Andrew",
                            30
                          ]
                        ], (function (param) {
                            var j = param[1];
                            var i = param[0];
                            return React.createElement("tr", {
                                        key: i + ("+" + j)
                                      }, React.createElement("td", {
                                            style: Css.style({
                                                  hd: Css.padding2(Css.px(4), Css.px(8)),
                                                  tl: /* [] */0
                                                })
                                          }, i), React.createElement("td", {
                                            style: Css.style({
                                                  hd: Css.padding2(Css.px(4), Css.px(8)),
                                                  tl: /* [] */0
                                                })
                                          }, j), React.createElement("td", {
                                            style: Css.style({
                                                  hd: Css.padding2(Css.px(4), Css.px(8)),
                                                  tl: /* [] */0
                                                })
                                          }, String(param[2])));
                          })))), React.createElement("p", undefined, "Alternatively, we can lay it out on a cross-table like this:"), React.createElement("div", {
                  style: Css.style({
                        hd: Css.overflowX(/* scroll */-949692403),
                        tl: /* [] */0
                      })
                }, React.createElement(GraphTable$BlossomPlayground.Table.make, {
                      vertices: vertices,
                      editVertex: editVertex,
                      editEdge: editEdge,
                      mates: Graph$BlossomPlayground.Mates.empty,
                      graph: SampleData$BlossomPlayground.a,
                      disabled: true,
                      style: Css.style({
                            hd: Css.margin(/* auto */-1065951377),
                            tl: /* [] */0
                          })
                    })), React.createElement("p", undefined, "In graph theory, each of the people is a \"vertex,\" and the\n        connection between each pair of people is an \"edge.\" Another way\n        to visualize it is like this:"), React.createElement(ForceGraph$BlossomPlayground.make, {
                  graph: SampleData$BlossomPlayground.a,
                  mates: Graph$BlossomPlayground.Mates.empty,
                  width: 400,
                  height: 400,
                  children: "Tap or mouse-over a circle to see who it represents.",
                  style: Css.style({
                        hd: Css.margin(/* auto */-1065951377),
                        tl: /* [] */0
                      }),
                  legend: false
                }), React.createElement("p", undefined, "Now we let the algorithm work its magic. It will find a series of\n        edges that have the highest possible combined weight, where no\n        vertex is listed twice, and where no vertex is without a mate. In\n        this example, the result is:"), React.createElement("ul", undefined, Belt_Array.map([
                      "Mary, Joseph",
                      "Matthew, Luke",
                      "Mark, James",
                      "John, Peter",
                      "Andrew, Philip"
                    ], (function (s) {
                        return React.createElement("li", {
                                    key: s
                                  }, s);
                      }))), React.createElement("p", undefined, "Or when we visualize it:"), React.createElement(ForceGraph$BlossomPlayground.make, {
                  graph: SampleData$BlossomPlayground.a,
                  mates: mates,
                  width: 400,
                  height: 400,
                  children: "Tap or mouse-over a circle to see who it represents.",
                  style: Css.style({
                        hd: Css.margin(/* auto */-1065951377),
                        tl: /* [] */0
                      })
                }), React.createElement("p", undefined, "Note that we couldn't use the edge with the highest weight because\n        choosing it would leave another vertex with no connections. We also\n        have to use the two edges with the lowest weights because we're\n        committed to matching as many vertices as possible."), React.createElement("p", undefined, "As you can see, finding the maximum weighted matching is often\n        unintuitive. Imagine how much more difficult this becomes when you\n        have dozens, or hundreds, of people, and we could potentially match\n        every person with anyone else!"), React.createElement("p", undefined, "Fortunately, the algorithm here figures it out for us almost\n        instantly. Try it out with some different data! It's powered by ", React.createElement("a", {
                      href: "https://github.com/johnridesabike/re-blossom",
                      target: "_blank"
                    }, "this implementation of the blossom algorithm"), "."), React.createElement("p", {
                  style: Css.style({
                        hd: Css.textAlign(/* center */98248149),
                        tl: /* [] */0
                      })
                }, React.createElement("button", {
                      onClick: (function (param) {
                          return close();
                        })
                    }, "Go to app")));
}

var make = Intro;

exports.make = make;
/* vertices Not a pure module */
